import {
  Box,
  FormGroup,
  Table,
  TableBody,
  TableHead,
  TableRow,
  styled,
  TableCell,
  TableContainer,
  Paper,
  FormHelperText,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAuthUser } from "react-auth-kit";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./LeadReportCreation.module.css";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import PieChart from "../../../../../components/PieChart/PieChart";
import CustomFilterAccordion from "../../../../../components/CustomFilterAccordion/CustomFilterAccordion";
import FilterTypeWrap from "../../../../../components/FilterDrawer/FilterTypeWrap";
import FilterCheckBoxWrap from "../../../../../components/FilterDrawer/FilterCheckBoxWrap";
import FilterCheckbox from "../../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import FilterSearchField from "../../../../../components/FilterDrawer/FilterSearchField/FilterSearchField";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CancelBtn from "../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import IconDropdown from "../../../../../components/Dropdowns/IconDropdown";
import SaveReportPopup from "../SaveReportPopup/SaveReportPopup";
import CancelModal from "../../../../../components/CancelModal/CancelModal";
import CourseDescriptionSkeleton from "../../../../../components/Skeletons/Course/CourseDescriptionSkeleton";
import TableSkeleton from "../../../../../components/Skeletons/TableSkeleton";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import AttendanceSkeleton from "../../../../../components/Skeletons/Attendance/AttendanceSkeleton";
import accordionDown from "../../../../../assets/images/accordion-down.svg";
import { DownloadReport } from "../../service/reports.request";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import {
  getReportById,
  getReportData,
  resetReportStatuses,
  saveReport,
} from "../../service/reportsSlice";
import BarChart from "../../../Dashboard/components/BarChart/BarChart";
import moment from "moment";
import { useCountries } from "use-react-countries";
import PageBackBtn from "../../../../../components/Buttons/PageBackBtn";
import helpIcon from "../../../../../assets/images/helpIcon.svg";

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  lineHeight: "18px",
  backgroundColor: "#073E53",
  color: "#FFFFFF",
  textTransform: "capitalize",
  fontWeight: "400",
  fontSize: 14,
  padding: 16,
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  fontSize: "14px",
  color: "#667085",
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "10px",
}));

interface CheckedBranch {
  id: string;
  branchName: string;
}

interface CheckedCourse {
  id: string;
  courseName: string;
}
interface CheckedStatuses {
  status: string;
}
interface CheckedTypes {
  type: string;
}
interface CheckedCountry {
  name: string;
}

const filterDates = [
  { label: "Week", value: "WEEK" },
  { label: "Month", value: "MONTH" },
  { label: "Quarter", value: "QUARTER" },
  { label: "Half Yearly", value: "HALF_YEARLY" },
  { label: "Yearly", value: "YEARLY" },
  { label: "Custom", value: "CUSTOM" },
];

function TransactionsReportCreation(props: any) {
  const { add } = props;
  const auth = useAuthUser();
  const user = auth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userById } = useSelector((state: any) => state.userDetails);

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const { countries } = useCountries();

  const {
    saveReportLoading,
    saveReportSuccess,
    reportWholeData,
    reportDataloading,
    reportById,
    reportByIdLoading,
  } = useSelector((state: any) => state.reports);

  const branches = useSelector((state: any) => state.branch.branchList);
  const courses = useSelector((state: any) => state.courses.courses);
  const batchList = useSelector((state: any) => state.batch.batchList);

  const filteredCountries = countries?.filter((country: any) =>
    branches?.some((branch: any) =>
      hasAllBranchAccess
        ? branch.country === country.name
        : branch.country === country.name && branch.id === userById?.branchId
    )
  );

  const [isBranchOpen, setIsBranchOpen] = useState<boolean>(false);
  const [isBatchOpen, setIsBatchOpen] = useState<boolean>(false);
  const [isCourseOpen, setIsCourseOpen] = useState<boolean>(false);
  const [isTypeOpen, setIsTypeOpen] = useState<boolean>(false);
  const [isDateOpen, setIsDateOpen] = useState<boolean>(false);
  const [isStatusOpen, setIsStatusOpen] = useState<boolean>(false);
  const [isCountryOpen, setIsCountryOpen] = useState<boolean>(false);

  const [cancel, setCancel] = useState<boolean>(false);
  const [openSaveReportPopup, setOpenSaveReportPopup] =
    useState<boolean>(false);
  const [collapseGraph, setCollapseGraph] = useState<boolean>(false);

  const [graphValues, setGraphValues] = useState<any>();

  const [batchSearchTerm, setBatchSearchTerm] = React.useState<string>("");
  const [branchSearchTerm, setBranchSearchTerm] = React.useState<string>("");
  const [courseSearchTerm, setCourseSearchTerm] = React.useState<string>("");

  const [checkedCourses, setCheckedCourses] = useState<any[]>([]);
  const [checkedBranches, setCheckedBranches] = useState<any[]>([]);
  const [checkedBatches, setCheckedBatches] = useState<any[]>([]);
  const [checkedTypes, setCheckedTypes] = useState<any[]>([]);
  const [checkedStatuses, setCheckedStatuses] = useState<any[]>([]);
  const [checkedDates, setCheckedDates] = useState<any[]>([]);
  const [checkedCountry, setCheckedCountry] = useState<any[]>([]);
  const [appliedCountry, setAppliedCountry] = useState<any[]>([]);

  const [startDate, setStartDate] = React.useState<any>(null);
  const [endDate, setEndDate] = React.useState<any>(null);
  const [endDateError, setEndDateError] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>("");
  const [reportName, setReportName] = React.useState<string>("");

  const filteredBranches = branches?.filter((branch: any) => {
    const matchesBranchAccess =
      hasAllBranchAccess || branch?.id === userById?.branchId;

    const matchesCheckedCountry =
      checkedCountry?.length === 0 ||
      checkedCountry?.some((c) => c?.name === branch?.country);

    return matchesBranchAccess && matchesCheckedCountry;
  });
  const filteredBranchesSearch = filteredBranches?.filter((branch: any) => {
    const matchesSearchTerm = branch?.branchName
      ?.toLowerCase()
      .includes(branchSearchTerm.toLowerCase());

    return matchesSearchTerm;
  });

  const filteredCourses = courses?.filter((item: any) => {
    const searchTermMatch =
      item?.courseName
        ?.toLowerCase()
        .indexOf(courseSearchTerm.toLowerCase()) !== -1;

    return searchTermMatch;
  });

  const filteredBatch = batchList?.filter((batch: any) => {
    const matchesBranchAccess =
      hasAllBranchAccess || batch?.branchId === userById?.branchId;

    const isValidBatch =
      batch.batchConductType === "REGULAR_BATCH" &&
      /* batch.batchStatus == 'COMPLETED' && */
      batch.batchStatus !== "CANCELLED" &&
      batch.status === "ACTIVE";

    const matchesSelectedBranches =
      checkedBranches?.length === 0 ||
      checkedBranches?.some((branch: any) => branch?.id === batch?.branchId);

    return matchesBranchAccess && isValidBatch && matchesSelectedBranches;
  });

  const filteredBatchSearch = filteredBatch?.filter((batch: any) => {
    const matchesSearchTerm = batch?.batchName
      ?.toLowerCase()
      .includes(batchSearchTerm?.toLowerCase());

    return matchesSearchTerm;
  });
  function findCountyByName(name: string) {
    return (
      countries?.find(
        (country: any) => country?.name?.toLowerCase() === name?.toLowerCase()
      ) || null
    );
  }
  const handleDateChange = (date: any, id: string) => {
    if (date !== null) {
      const dateMilliseconds = date.unix() * 1000;

      if (id === "startDate") {
        const startOfDay = dayjs(dateMilliseconds).startOf("day").valueOf();
        setStartDate(startOfDay);

        if (startOfDay > endDate) {
          setEndDateError("End date should be after start date");
        } else if (startOfDay === dayjs(endDate).startOf("day").valueOf()) {
          setEndDateError("Start date and end date cannot be the same");
        } else {
          setEndDateError("");
        }
      } else if (id === "endDate") {
        const endOfDay = dayjs(dateMilliseconds).endOf("day").valueOf();
        setEndDate(endOfDay);

        if (startDate > endOfDay) {
          setEndDateError("End date should be after start date");
        } else if (
          dayjs(startDate).startOf("day").valueOf() ===
          dayjs(endOfDay).startOf("day").valueOf()
        ) {
          setEndDateError("Start date and end date cannot be the same");
        } else {
          setEndDateError("");
        }
      }
    }
  };
  const handleFilterBranchChecked = (id: string, branchName: string) => {
    if (branchName === "ALL") {
      if (
        checkedBranches.length ===
        [{ id: "0", branchName: "ALL" }, ...filteredBranches].length
      ) {
        setCheckedBranches([]);
        setCheckedBatches([]);
      } else {
        const allBranches = filteredBranches?.map((d: any) => ({
          id: d?.id,
          branchName: d?.branchName,
        }));
        setCheckedBranches([...allBranches, { id: "0", branchName: "ALL" }]);
      }
    } else {
      const branchToAdd: CheckedBranch = { id, branchName };
      const isAllSelected = checkedBranches.some(
        (branch) => branch.branchName === "ALL"
      );

      let updatedBranches;
      if (checkedBranches.some((branch) => branch.id === id)) {
        updatedBranches = checkedBranches.filter((branch) => branch.id !== id);
        if (isAllSelected) {
          updatedBranches = updatedBranches.filter(
            (branch) => branch.branchName !== "ALL"
          );
        }
      } else {
        updatedBranches = [...checkedBranches, branchToAdd];
      }

      const selectedBranchIds = new Set(updatedBranches.map((b) => b.id));
      const allBranchesSelected = filteredBranches.every((branch: any) =>
        selectedBranchIds.has(branch.id)
      );

      if (allBranchesSelected) {
        updatedBranches = [...updatedBranches, { id: "0", branchName: "ALL" }];
      } else {
        updatedBranches = updatedBranches.filter(
          (branch) => branch.branchName !== "ALL"
        );
      }

      setCheckedBranches(updatedBranches);

      if (checkedBatches.length > 0) {
        const checkedBatchIds = new Set(
          checkedBatches.map((batch) => batch.id)
        );

        const filteredBatches = batchList
          ?.filter((batch: any) => checkedBatchIds.has(batch.id))
          ?.filter((batch: any) => selectedBranchIds.has(batch.branchId));

        setCheckedBatches(
          filteredBatches.map((item: any) => ({
            id: item?.id,
            batchName: item?.batchName,
          }))
        );
      }
    }
  };

  const handleFilterCourseChecked = (id: string, courseName: string) => {
    if (courseName === "ALL") {
      if (checkedCourses.length === courses.length + 1) {
        setCheckedCourses([]); // Unselect all
      } else {
        const allCourses = courses.map((d: any) => ({
          id: d.id,
          courseName: d.courseName,
        }));
        setCheckedCourses([...allCourses, { id: "0", courseName: "ALL" }]);
      }
    } else {
      const courseToAdd: CheckedCourse = { id, courseName };
      const isAllSelected = checkedCourses.some(
        (course) => course.courseName === "ALL"
      );

      let updatedCheckedCourses: CheckedCourse[] = [];

      if (checkedCourses.some((course) => course.id === id)) {
        updatedCheckedCourses = checkedCourses.filter(
          (course) => course.id !== id
        );

        if (isAllSelected) {
          updatedCheckedCourses = updatedCheckedCourses.filter(
            (course) => course.courseName !== "ALL"
          );
        }
      } else {
        updatedCheckedCourses = [...checkedCourses, courseToAdd];

        if (updatedCheckedCourses.length === courses.length) {
          updatedCheckedCourses.push({ id: "0", courseName: "ALL" });
        }
      }

      setCheckedCourses(updatedCheckedCourses);

      if (checkedBatches?.length > 0) {
        const selectedCourseIds = new Set(
          updatedCheckedCourses.map((c) => c.id)
        );
        const checkedBatchIds = new Set(
          checkedBatches.map((batch) => batch.id)
        );
        const filteredBatches = batchList
          ?.filter((batch: any) => checkedBatchIds.has(batch.id))
          ?.filter((batch: any) => selectedCourseIds.has(batch.courseId));

        setCheckedBatches(
          filteredBatches.map((item: any) => ({
            id: item?.id,
            batchName: item?.batchName,
          }))
        );
      }
    }
  };

  const handleFilterBatchChecked = (id: string, batchName: string) => {
    if (batchName === "ALL") {
      if (
        checkedBatches.length ===
        [{ id: "0", batchName: "ALL" }, ...filteredBatch].length
      ) {
        setCheckedBatches([]);
      } else {
        const allBatch = filteredBatch?.map((d: any) => {
          return { id: d?.id, batchName: d?.branchName };
        });
        setCheckedBatches([...allBatch, { id: "0", batchName: "ALL" }]);
      }
    } else {
      const batchToAdd: any = { id, batchName };
      const isAllSelected = checkedBatches.some(
        (batch) => batch.batchName === "ALL"
      );

      if (checkedBatches.some((branch) => branch.id === id)) {
        const updatedBatches = checkedBatches.filter(
          (course) => course.id !== id
        );
        if (isAllSelected) {
          setCheckedBatches(
            updatedBatches.filter((batch: any) => batch.batchName !== "ALL")
          );
        } else {
          setCheckedBatches(updatedBatches);
        }
      } else {
        const updatedCheckedBatches = [...checkedBatches, batchToAdd];

        const allBatch = filteredBatch?.map((d: any) => ({
          id: d?.id,
          batchName: d?.batchName,
        }));

        if (
          allBatch.every((batch: any) =>
            updatedCheckedBatches.some((b) => b.id === batch.id)
          )
        ) {
          setCheckedBatches([
            ...updatedCheckedBatches,
            { id: "0", batchName: "ALL" },
          ]);
        } else {
          setCheckedBatches(updatedCheckedBatches);
        }
      }
    }
  };

  const handleFilterStatusChecked = (itemStatus: string) => {
    const statusToAdd: CheckedStatuses = { status: itemStatus };
    setCheckedStatuses([statusToAdd]);
    if (checkedStatuses.some((item) => item.status === itemStatus)) {
      setCheckedStatuses(
        checkedStatuses.filter((item) => item.status !== itemStatus)
      );
    } else {
      setCheckedStatuses([...checkedStatuses, statusToAdd]);
    }
  };

  const handleFilterTypeChecked = (itemType: string) => {
    const typeToAdd: CheckedTypes = { type: itemType };
    setCheckedTypes([typeToAdd]);
    if (checkedTypes.some((item) => item.type === itemType)) {
      setCheckedTypes(checkedTypes.filter((item) => item.type !== itemType));
    } else {
      setCheckedTypes([...checkedTypes, typeToAdd]);
    }
  };

  const handleFilterDateChecked = (itemType: string) => {
    const dateToAdd: CheckedTypes = { type: itemType };
    setCheckedDates([dateToAdd]);
    setStartDate(null);
    setEndDate(null);
  };

  const handleFilterCountryChecked = (country: string) => {
    const countryToAdd: CheckedCountry = { name: country };
    setCheckedCountry([countryToAdd]);
    setCheckedBranches([]);
    setCheckedBatches([]);
  };

  const handleResetFilter = () => {
    setCheckedBranches([]);
    setCheckedBatches([]);
    setCheckedCourses([]);
    setCheckedTypes([]);
    setCheckedDates([]);
    setCheckedStatuses([]);
    setCheckedCountry([]);
  };

  const handleFilterApply = () => {
    if (checkedDates?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select date filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (
      checkedDates?.length > 0 &&
      checkedDates?.[0]?.type === "CUSTOM" &&
      startDate === null
    ) {
      dispatch(
        setToastNotification({
          message: "Please select start date for date filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (
      checkedDates?.length > 0 &&
      checkedDates?.[0]?.type === "CUSTOM" &&
      endDate === null
    ) {
      dispatch(
        setToastNotification({
          message: "Please select end date for date filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedTypes?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select type filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedStatuses?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select status filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedCountry?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select a country",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedBranches?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select branch filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedCourses?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select course filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedBatches?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select batch filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else {
      const hasAllBranches = checkedBranches?.some(
        (branch: any) => branch?.branchName === "ALL"
      );
      const hasAllBatches = checkedBatches?.some(
        (batch: any) => batch?.batchName === "ALL"
      );
      const hasAllCourses = checkedCourses.some(
        (course: any) => course.courseName === "ALL"
      );
      setIsBranchOpen(false);
      setIsBatchOpen(false);
      setIsCourseOpen(false);
      setIsTypeOpen(false);
      setIsDateOpen(false);

      const dateData = {
        type: checkedDates?.[0]?.type,
        startDate: checkedDates?.[0]?.type === "CUSTOM" ? startDate : 0,
        endDate: checkedDates?.[0]?.type === "CUSTOM" ? endDate : 0,
      };

      const data = {
        reportType: "TRANSACTION",
        instituteId: activeInstitute?.id,
        generateReports: true,
        courseId: hasAllCourses
          ? "ALL"
          : checkedCourses?.map((d: any) => d?.id),
        branchId: !hasAllBranchAccess
          ? checkedBranches
              ?.filter((d: any) => d?.id !== "0")
              ?.map((d: any) => d?.id)
          : hasAllBranches
          ? "ALL"
          : checkedBranches?.map((d: any) => d?.id),
        batchId: !hasAllBranchAccess
          ? checkedBatches
              ?.filter((d: any) => d?.id !== "0")
              ?.map((d: any) => d?.id)
          : hasAllBatches
          ? "ALL"
          : checkedBatches?.map((d: any) => d?.id),
        paymentMode: checkedTypes?.map((d: any) => d?.type) || [],
        paymentStatus: checkedStatuses?.map((d: any) => d?.status) || [],
        date: dateData,
        branchCountry: checkedCountry?.[0]?.name,
      };
      dispatch<any>(getReportData(data));
    }
  };

  const handleDownload = () => {
    const flatttenedArray = reportWholeData?.result.flatMap(
      (item: any) => item
    );

    const data = {
      action: "DOWNLOAD",
      reportType: "TRANSACTION",
      reportData: flatttenedArray,
    };

    DownloadReport(data)
      .then((res: any) => {
        const blob = base64ToBlob(
          res?.data?.data?.fileBase64String,
          "application/vnd.ms-excel"
        );
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "transactionReport.xlsx";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        dispatch(
          setToastNotification({
            message: "Congratulations! Report is successfully downloaded.",
            type: "success",
            snackOpen: true,
          })
        );
      })
      .catch((err: any) => {});
  };

  const base64ToBlob = (base64Data: string, contentType: any) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const handleSaveClick = async (event: any) => {
    event.preventDefault();
    const data = {
      instituteId: activeInstitute?.id,
      name: reportName,
      category: "TRANSACTION",
      description: description,
      reportData: reportWholeData,
      createdById: user?.institute[0]?.id,
      createdByName: `${user?.institute[0]?.firstName} ${user?.institute[0]?.lastName}`,
    };
    dispatch<any>(saveReport(data));
  };

  const result = add ? reportWholeData?.result : reportById?.reportData?.result;

  const onCancel = () => {
    setCancel(false);
  };

  const noCancelModal = () => {
    setCancel(false);
  };

  const yesCancelModal = () => {
    setCancel(false);
    location?.state?.from === "RecentReports"
      ? navigate("/app/Reports/RecentReports")
      : location?.state?.from === "CreatedByMe"
      ? navigate("/app/Reports/CreatedByMe")
      : navigate("/app/Reports/AllReports");
  };

  useEffect(() => {
    if (add) {
      const getBranch = branches?.find(
        (item: any) => item?.id === userById?.branchId
      );

      const data = {
        reportType: "TRANSACTION",
        instituteId: activeInstitute?.id,
        generateReports: true,
        courseId: "ALL",
        branchId: "ALL",
        batchId: "ALL",
        paymentMode: ["ONLINE", "OFFLINE"],
        paymentStatus: ["PAID", "FAILED"],
        branchCountry: getBranch?.country,
        date: {
          type: "WEEK",
          startDate: 0,
          endDate: 0,
        },
      };

      if (hasAllBranchAccess) {
        dispatch<any>(getReportData(data));
      } else {
        const ownBranchData = {
          reportType: "TRANSACTION",
          instituteId: activeInstitute?.id,
          generateReports: true,
          branchCountry: getBranch?.country,
          courseId: "ALL",
          branchId: filteredBranches?.map((d: any) => {
            return d?.id;
          }),
          batchId: filteredBatch?.map((d: any) => {
            return d?.id;
          }),
          paymentMode: ["ONLINE", "OFFLINE"],
          paymentStatus: ["PAID", "FAILED"],
          date: {
            type: "WEEK",
            startDate: 0,
            endDate: 0,
          },
        };
        dispatch<any>(getReportData(ownBranchData));
      }
    } else {
      const pathname = window.location.pathname;
      const reportId = pathname.substring(pathname.lastIndexOf("/") + 1);
      dispatch<any>(getReportById(reportId));
    }
  }, [branches, userById]);

  const findNamesbyId = (fieldName: any, id: string) => {
    if (fieldName === "COURSE" && id) {
      const courseName = courses?.filter(
        (d: any) =>
          d?.id.toString().toLowerCase() === id.toString().toLowerCase()
      );
      return courseName && courseName[0]?.courseName;
    } else if (fieldName === "BATCH" && id) {
      const batchName = batchList?.filter(
        (d: any) =>
          d?.id.toString().toLowerCase() === id.toString().toLowerCase()
      );

      return batchName && batchName[0]?.batchName;
    } else if (fieldName === "BRANCH" && id) {
      const branchName = filteredBranches?.filter((d: any) => d?.id === id);
      return branchName && branchName[0]?.branchName;
    }
  };
  useEffect(() => {
    if (
      reportWholeData?.appliedFilter ||
      reportById?.reportData?.appliedFilter
    ) {
      const dataFromNavigateion = add
        ? reportWholeData?.appliedFilter
        : reportById?.reportData?.appliedFilter;
      const branchIdArray = dataFromNavigateion?.find(
        (item: any) => item.branchId
      )?.branchId;
      const batchIdArray = dataFromNavigateion?.find(
        (item: any) => item.batchId
      )?.batchId;
      const courseIdArray = dataFromNavigateion?.find(
        (item: any) => item.courseId
      )?.courseId;
      const countryCheck = dataFromNavigateion?.find(
        (item: any) => item.branchCountry
      )?.branchCountry;
      const statusArray = dataFromNavigateion?.find(
        (item: any) => item.paymentStatus
      )?.paymentStatus;
      const typeArray = dataFromNavigateion?.find(
        (item: any) => item.paymentMode
      )?.paymentMode;
      const dateData = dataFromNavigateion?.find(
        (item: any) => item.date
      )?.date;

      const filterBranches = branches?.filter(
        (item: any) =>
          item?.country === countryCheck &&
          (hasAllBranchAccess || item?.id === userById?.branchId)
      );
      const filterBatches = batchList?.filter(
        (batch: any) =>
          batch.batchConductType === "REGULAR_BATCH" &&
          /* 	batch.batchStatus !== 'COMPLETED' && */
          batch.batchStatus !== "CANCELLED" &&
          batch.status === "ACTIVE" &&
          (hasAllBranchAccess || batch?.branchId === userById?.branchId) &&
          filterBranches?.some((branch: any) => branch.id === batch.branchId)
      );
      if (statusArray?.length > 0) {
        const statusData = statusArray?.map((item: any) => ({
          status: item,
        }));
        setCheckedStatuses(statusData);
      }
      if (typeArray?.length > 0) {
        const typeData = typeArray?.map((item: any) => ({
          type: item,
        }));
        setCheckedTypes(typeData);
      }
      if (countryCheck) {
        setCheckedCountry([{ name: countryCheck }]);
        setAppliedCountry([{ name: countryCheck }]);
      }
      if (dateData?.type !== "") {
        if (dateData?.type === "CUSTOM") {
          setStartDate(dateData?.startDate);
          setEndDate(dateData?.endDate);
        }
        setCheckedDates([{ type: dateData?.type }]);
      }

      if (
        branchIdArray === "ALL" ||
        branchIdArray?.length === filterBranches?.length
      ) {
        const alllBranches =
          filterBranches?.map((d: any) => {
            return { id: d?.id, branchName: d?.branchName };
          }) || [];
        setCheckedBranches([...alllBranches, { id: "0", branchName: "ALL" }]);
      } else {
        const aa = branchIdArray?.map((d: any) => {
          return { id: d, branchName: findNamesbyId("BRANCH", d) };
        });
        setCheckedBranches(aa);
      }
      if (
        batchIdArray === "ALL" ||
        batchIdArray?.length === filterBatches?.length
      ) {
        const alllBatches =
          filterBatches?.map((d: any) => {
            return { id: d?.id, batchName: d?.batchName };
          }) || [];
        setCheckedBatches([...alllBatches, { id: "0", batchName: "ALL" }]);
      } else {
        const aa = batchIdArray?.map((d: any) => {
          return { id: d, batchName: findNamesbyId("BATCH", d) };
        });
        setCheckedBatches(aa);
      }

      if (courseIdArray === "ALL") {
        const alllCourse =
          filteredCourses?.map((d: any) => {
            return { id: d?.id, courseName: d?.courseName };
          }) || [];
        setCheckedCourses([...alllCourse, { id: "0", courseName: "ALL" }]);
      } else {
        const aa = courseIdArray?.map((d: any) => {
          return { id: d, courseName: findNamesbyId("COURSE", d) };
        });
        setCheckedCourses(aa);
      }
    }
  }, [reportWholeData, reportById, add, userById, branches, batchList]);

  useEffect(() => {
    if (reportWholeData) {
      setGraphValues(reportWholeData);
    }
  }, [reportWholeData]);

  React.useEffect(() => {
    if (saveReportSuccess !== false && saveReportSuccess !== false) {
      dispatch(resetReportStatuses());
      navigate(`/app/Reports/RecentReports`);
    }
  }, [saveReportSuccess]);
  return (
    <>
      <Box
        sx={{
          overflow: "hidden",
          padding: "14px 16px",
          background: "#EEEEEE",
          maxHeight: "calc(100vh - 65px)",
          position: "relative",
          scrollbarWidth: "none",
        }}
      >
        {(add && reportWholeData === null) || reportByIdLoading ? (
          <AttendanceSkeleton />
        ) : (
          <Box
            sx={{
              backgroundColor: "#F5F5F5",
              display: "flex",
              maxHeight: "calc(100vh - 65px)",
              minHeight: "calc(100vh - 65px)",
              scrollbarWidth: "none",
            }}
          >
            <Box
              sx={{
                background: "#fff",
                minWidth: "240px",
                maxWidth: "240px",
                borderRight: "1px solid #E9E9E9",
              }}
              className="datepicker-container"
            >
              <div className={styles.reportFilterHead}>
                <div className={styles.headerText}>Custom</div>
                {add &&
                  (checkedDates?.length > 0 ||
                    checkedTypes?.length > 0 ||
                    checkedBatches?.length > 0 ||
                    checkedBranches?.length > 0 ||
                    checkedCourses?.length > 0 ||
                    checkedStatuses?.length > 0) && (
                    <div
                      className={styles.clearFilterText}
                      onClick={() => {
                        handleResetFilter();
                      }}
                    >
                      Clear All
                    </div>
                  )}
              </div>

              {add && (
                <div className={styles.filterApplyBtnWrap}>
                  <SaveBtn
                    buttonText={"Apply"}
                    onClick={() => {
                      handleFilterApply();
                    }}
                    loader={reportDataloading}
                    disabled={reportDataloading}
                  />
                </div>
              )}

              <div className={styles.filterContainer}>
                <CustomFilterAccordion
                  title="Date"
                  isOpen={isDateOpen}
                  setIsOpen={setIsDateOpen}
                  disabled={!add}
                  singleSelect={true}
                  singleSelectValue={checkedDates?.[0]?.type
                    ?.replace(/_/g, " ")
                    ?.toLowerCase()}
                >
                  <FilterTypeWrap>
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {filterDates?.map((item: any) => (
                          <FilterCheckbox
                            key={item.id}
                            keyVal={item.id}
                            checked={checkedDates?.some(
                              (data: any) => data?.type === item?.value
                            )}
                            checkboxFunction={() =>
                              handleFilterDateChecked(item.value)
                            }
                            label={item?.label}
                          />
                        ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                  {checkedDates?.[0]?.type === "CUSTOM" && (
                    <div
                      style={{
                        marginTop: "5px",
                        border: "1px solid #D0D5DDCC",
                        padding: "10px 16px",
                      }}
                    >
                      <div style={{ marginBottom: "16px" }}>
                        <div
                          style={{
                            fontSize: "13px",
                            color: "#667085B2",
                            marginBottom: "5PX",
                          }}
                        >
                          Start Date
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{
                              minHeight: "20px",
                              ".MuiInputBase-root": {
                                fontSize: "12px",
                                minHeight: "20px",
                                color: "#11C89B",
                                fontWeight: "600",
                              },
                              ".MuiFormLabel-root": {
                                lineHeight: "1",
                              },
                              ".MuiSvgIcon-root": {
                                fontSize: "18px",
                              },
                            }}
                            format="DD - MMM - YY"
                            onChange={(date) =>
                              handleDateChange(date, "startDate")
                            }
                            value={startDate ? dayjs(startDate) : null}
                            disableFuture
                          />
                        </LocalizationProvider>
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: "13px",
                            color: "#667085B2",
                            marginBottom: "5PX",
                          }}
                        >
                          End Date
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{
                              minHeight: "20px",
                              ".MuiInputBase-root": {
                                fontSize: "12px",
                                minHeight: "20px",
                                color: "#EC3939",
                                fontWeight: "600",
                              },
                              ".MuiFormLabel-root": {
                                lineHeight: "1",
                              },
                              ".MuiSvgIcon-root": {
                                fontSize: "18px",
                              },
                            }}
                            format="DD - MMM - YY"
                            onChange={(date) =>
                              handleDateChange(date, "endDate")
                            }
                            value={endDate ? dayjs(endDate) : null}
                            disableFuture
                          />
                        </LocalizationProvider>
                        {endDateError !== "" && (
                          <FormHelperText error={true}>
                            {endDateError}
                          </FormHelperText>
                        )}
                      </div>
                    </div>
                  )}
                </CustomFilterAccordion>
                <CustomFilterAccordion
                  title="Status"
                  isOpen={isStatusOpen}
                  setIsOpen={setIsStatusOpen}
                  count={checkedStatuses?.length}
                  disabled={!add}
                >
                  <FilterTypeWrap>
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {[
                          { label: "Successful", value: "PAID" },
                          { label: "Failed", value: "FAILED" },
                        ]?.map((item: any, index: number) => (
                          <FilterCheckbox
                            key={`${item?.value}-${index}`}
                            keyVal={`${item?.value}-${index}`}
                            checked={checkedStatuses?.some(
                              (data: any) => data?.status === item?.value
                            )}
                            checkboxFunction={() =>
                              handleFilterStatusChecked(item.value)
                            }
                            label={<span>{item?.label}</span>}
                            countColor={
                              item.value === "PAID" ? "#11C89B" : "#EC3939"
                            }
                            filterCount={
                              add
                                ? item.value === "PAID"
                                  ? reportWholeData?.totalTransactionsStatus
                                      ?.totalPaid
                                  : reportWholeData?.totalTransactionsStatus
                                      ?.totalFailed
                                : item.value === "PAID"
                                ? reportById?.reportData
                                    ?.totalTransactionsStatus?.totalPaid
                                : reportById?.reportData
                                    ?.totalTransactionsStatus?.totalFailed
                            }
                            showResultCount={true}
                          />
                        ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
                <CustomFilterAccordion
                  title="Type"
                  isOpen={isTypeOpen}
                  setIsOpen={setIsTypeOpen}
                  count={checkedTypes?.length}
                  disabled={!add}
                >
                  <FilterTypeWrap>
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {[
                          { label: "Online", value: "ONLINE" },
                          { label: "Offline", value: "OFFLINE" },
                        ]?.map((item: any, index: number) => (
                          <FilterCheckbox
                            key={`${item?.value}-${index}`}
                            keyVal={`${item?.value}-${index}`}
                            checked={checkedTypes?.some(
                              (data: any) => data?.type === item?.value
                            )}
                            checkboxFunction={() =>
                              handleFilterTypeChecked(item.value)
                            }
                            label={item?.label}
                            filterCount={
                              add
                                ? item.value === "ONLINE"
                                  ? reportWholeData?.totalPaymentMode
                                      ?.totalOnline
                                  : reportWholeData?.totalPaymentMode
                                      ?.totalOffline
                                : item.value === "ONLINE"
                                ? reportById?.reportData?.totalPaymentMode
                                    ?.totalOnline
                                : reportById?.reportData?.totalPaymentMode
                                    ?.totalOffline
                            }
                            countColor={
                              item.value === "ONLINE" ? "#11C89B" : "#EC3939"
                            }
                            showResultCount={true}
                          />
                        ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
                <CustomFilterAccordion
                  title="Country"
                  isOpen={isCountryOpen}
                  setIsOpen={setIsCountryOpen}
                  disabled={!add}
                  singleSelect={true}
                  singleSelectValue={checkedCountry?.[0]?.name?.toLowerCase()}
                >
                  <FilterTypeWrap>
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {filteredCountries?.map((item: any, index: number) => (
                          <FilterCheckbox
                            key={`${item?.name}-${index}`}
                            keyVal={`${item?.name}-${index}`}
                            checked={checkedCountry?.some(
                              (data: any) => data?.name === item?.name
                            )}
                            checkboxFunction={() =>
                              handleFilterCountryChecked(item.name)
                            }
                            label={item?.name}
                          />
                        ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
                <CustomFilterAccordion
                  title="Branch"
                  isOpen={isBranchOpen}
                  setIsOpen={setIsBranchOpen}
                  count={checkedBranches?.length}
                  disabled={!add}
                >
                  <FilterTypeWrap>
                    <FilterSearchField
                      value={branchSearchTerm}
                      onChange={(e: any) => {
                        setBranchSearchTerm(e.target.value);
                      }}
                      placeholder="Search Branch"
                    />
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {branches &&
                          [
                            { branchName: "ALL", id: "0" },
                            ...filteredBranchesSearch,
                          ]?.map((item: any) => (
                            <FilterCheckbox
                              key={item?.id}
                              keyVal={item?.id}
                              checked={checkedBranches?.some(
                                (data) => data?.id === item?.id
                              )}
                              checkboxFunction={() =>
                                handleFilterBranchChecked(
                                  item.id,
                                  item.branchName
                                )
                              }
                              label={item?.branchName?.toLowerCase()}
                            />
                          ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
                <CustomFilterAccordion
                  title="Course"
                  isOpen={isCourseOpen}
                  setIsOpen={setIsCourseOpen}
                  count={checkedCourses?.length}
                  disabled={!add}
                >
                  <FilterTypeWrap>
                    <FilterSearchField
                      value={courseSearchTerm}
                      onChange={(e: any) => {
                        setCourseSearchTerm(e.target.value);
                      }}
                      placeholder="Search Course"
                    />
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {courses &&
                          [
                            { courseName: "ALL", id: "0" },
                            ...filteredCourses,
                          ]?.map((item: any) => (
                            <FilterCheckbox
                              key={item?.id}
                              keyVal={item?.id}
                              checked={checkedCourses?.some(
                                (data) => data?.id === item?.id
                              )}
                              checkboxFunction={() =>
                                handleFilterCourseChecked(
                                  item.id,
                                  item.courseName
                                )
                              }
                              label={item?.courseName?.toLowerCase()}
                            />
                          ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
                <CustomFilterAccordion
                  title="Batch"
                  isOpen={isBatchOpen}
                  setIsOpen={setIsBatchOpen}
                  count={checkedBatches?.length}
                  disabled={!add}
                >
                  <FilterTypeWrap>
                    <FilterSearchField
                      value={batchSearchTerm}
                      onChange={(e: any) => setBatchSearchTerm(e.target.value)}
                      placeholder="Search Batch"
                    />
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {batchList &&
                          [
                            { batchName: "ALL", id: "0" },
                            ...filteredBatchSearch,
                          ]?.map((item: any) => (
                            <FilterCheckbox
                              key={item.id}
                              keyVal={item.id}
                              checked={checkedBatches?.some(
                                (data) => data?.id === item?.id
                              )}
                              checkboxFunction={() =>
                                handleFilterBatchChecked(
                                  item.id,
                                  item.batchName
                                )
                              }
                              isBatchCompleted={
                                item?.batchStatus === "COMPLETED" ? true : false
                              }
                              label={item.batchName.toLowerCase()}
                            />
                          ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
              </div>
            </Box>

            <Box
              sx={{
                background: "#fff",
                width: "calc(100% - 240px)",
              }}
            >
              {!add ? (
                <div className={styles.batchHeader}>
                  <PageBackBtn
                    onClick={() => {
                      location?.state?.from === "RecentReports"
                        ? navigate("/app/Reports/RecentReports")
                        : location?.state?.from === "CreatedByMe"
                        ? navigate("/app/Reports/CreatedByMe")
                        : navigate("/app/Reports/AllReports");
                    }}
                    iconOnly={true}
                  />
                  <div className={styles.headerText}>
                    {`${location?.state?.reportName}`}
                  </div>

                  <button
                    className={styles.graphCollapseBtn}
                    onClick={() => setCollapseGraph(!collapseGraph)}
                  >
                    Graph{" "}
                    <img
                      src={accordionDown}
                      alt=""
                      style={{
                        marginLeft: "5px",
                        transform: collapseGraph ? "rotate(180deg)" : "none",
                        transition: "0.2s ease-in-out",
                      }}
                    />
                  </button>
                </div>
              ) : (
                <div className={styles.batchHeader}>
                  <div className={styles.headerText}>
                    {!add ? `${reportById?.name}` : "Reports - Transaction"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    <button
                      className={styles.graphCollapseBtn}
                      onClick={() => setCollapseGraph(!collapseGraph)}
                    >
                      Graph{" "}
                      <img
                        src={accordionDown}
                        alt=""
                        style={{
                          marginLeft: "5px",
                          transform: collapseGraph ? "rotate(180deg)" : "none",
                          transition: "0.2s ease-in-out",
                        }}
                      />
                    </button>
                    <CancelBtn
                      onClick={() => {
                        setCancel(true);
                      }}
                    />
                    <SaveBtn
                      onClick={() => {
                        setOpenSaveReportPopup(true);
                      }}
                      disabled={result?.length === 0}
                    />
                    <div style={{ marginLeft: "5px" }}>
                      <IconDropdown
                        options={[
                          {
                            label: "Download",
                            onClick: () => {
                              handleDownload();
                            },
                            style: { color: "#667085" },
                          },
                        ]}
                        isDownloadButton={true}
                        disabled={result?.length === 0}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div
                style={{
                  overflowY: "scroll",
                  height: "78vh",
                }}
              >
                <div
                  className={styles.graphContainer}
                  style={{
                    margin: collapseGraph ? "20px 20px" : "10px 20px",
                  }}
                >
                  {reportDataloading || reportByIdLoading ? (
                    <CourseDescriptionSkeleton />
                  ) : (
                    <>
                      {collapseGraph && (
                        <div
                          className={styles.lineGraphContainer}
                          style={{ maxHeight: "380PX" }}
                        >
                          <div className={styles.transReportBarHead}>
                            <div className={styles.transReportBarTitle}>
                              Transactions
                            </div>
                            <div className={styles.transReportBarRight}>
                              <div className={styles.transReportBarBox}>
                                <div className={styles.transReportBarBoxLabel}>
                                  Total Transactions
                                </div>
                                <div className={styles.transReportBarBoxValue}>
                                  {!add
                                    ? reportById?.reportData
                                        ?.totalTransactionsStatus?.totalFailed +
                                      reportById?.reportData
                                        ?.totalTransactionsStatus?.totalPaid
                                    : reportWholeData?.totalTransactionsStatus
                                        ?.totalFailed +
                                      reportWholeData?.totalTransactionsStatus
                                        ?.totalPaid}
                                </div>
                              </div>
                              <div className={styles.transReportBarBox}>
                                <div className={styles.transReportBarBoxLabel}>
                                  Transaction Amount
                                </div>
                                <div
                                  className={styles.transReportBarBoxValue}
                                  style={{
                                    direction: [
                                      "Arabic",
                                      "Hebrew",
                                      "Urdu",
                                      "Farsi",
                                    ].some((lang) =>
                                      findCountyByName(
                                        appliedCountry?.[0]?.name
                                      )?.languages?.includes(lang)
                                    )
                                      ? "rtl"
                                      : "ltr",
                                  }}
                                >
                                  {
                                    findCountyByName(appliedCountry?.[0]?.name)
                                      ?.currencies?.[0]?.symbol
                                  }
                                  {!add
                                    ? reportById?.reportData
                                        ?.totalTransactionsStatus
                                        ?.totalTransactionAmount
                                    : reportWholeData?.totalTransactionsStatus
                                        ?.totalTransactionAmount}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={styles.helpIconWrap}>
                            <Tooltip
                              arrow
                              placement="right"
                              title={
                                "Few entries are not shown in the graph due to clustering but all the entries can be viewed in the table below."
                              }
                              PopperProps={{ style: { zIndex: 9999999 } }}
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "#101828",
                                    color: "#fff",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    padding: "8px 12px",
                                    "& .MuiTooltip-arrow": {
                                      color: "#101828",
                                    },
                                  },
                                },
                              }}
                            >
                              <span>
                                <img src={helpIcon} alt="helpIcon" />
                              </span>
                            </Tooltip>
                          </div>
                          <div
                            style={{ maxHeight: "240PX", minHeight: "240px" }}
                          >
                            <BarChart
                              data={
                                !add
                                  ? reportById?.reportData?.lineGraphData
                                      ?.datasets
                                  : graphValues?.lineGraphData?.datasets
                              }
                              labels={
                                !add
                                  ? reportById?.reportData?.lineGraphData
                                      ?.labels
                                  : graphValues?.lineGraphData?.labels
                              }
                              place={"TRANSACTION_REPORT"}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  {reportDataloading || reportByIdLoading ? (
                    <CourseDescriptionSkeleton />
                  ) : (
                    <>
                      {collapseGraph && (
                        <div
                          className={styles.pieGraphContainer}
                          style={{ minHeight: "380px" }}
                        >
                          <PieChart
                            title={"transactions"}
                            result={!add ? reportById?.reportData : graphValues}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div
                  style={{
                    margin: collapseGraph ? "30px 20px" : "10px 20px",
                  }}
                >
                  {reportDataloading || reportByIdLoading ? (
                    <TableSkeleton />
                  ) : (
                    <TableContainer
                      component={Paper}
                      sx={{
                        borderRadius: "8px",
                        border: "1px solid #EAECF0",
                        height: "calc(100vh - 100px)",
                        overflowY: "scroll",
                        boxShadow: "none",
                        flexGrow: 1,
                        width: "100%",
                        maxHeight: "calc(100vh - 220px)",
                        minHeight: "calc(100vh - 220px)",
                      }}
                    >
                      <Table sx={{ minWidth: 700 }}>
                        <TableHead
                          sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 999,
                          }}
                        >
                          <TableRow>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 50,
                              }}
                            >
                              #
                            </StyledTableCellHead>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 200,
                                // padding: " 16px 8px",
                              }}
                            >
                              Name
                              {`${
                                result?.length > 0 ? `(${result?.length})` : ""
                              }`}
                            </StyledTableCellHead>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 200,
                                // padding: " 16px 8px",
                              }}
                            >
                              Course Name
                            </StyledTableCellHead>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 200,
                                // padding: " 16px 8px",
                              }}
                            >
                              Batch Name
                            </StyledTableCellHead>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 170,
                              }}
                            >
                              Transaction Amount
                            </StyledTableCellHead>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 200,
                              }}
                            >
                              Transaction Date & Time
                            </StyledTableCellHead>

                            <StyledTableCellHead
                              sx={{
                                minWidth: 100,
                              }}
                            >
                              Status
                            </StyledTableCellHead>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 100,
                              }}
                            >
                              Type
                            </StyledTableCellHead>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 130,
                              }}
                            >
                              Payment Mode
                            </StyledTableCellHead>
                            <StyledTableCellHead
                              sx={{
                                minWidth: 130,
                              }}
                            >
                              Invoice Number
                            </StyledTableCellHead>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {result?.map((report: any, index: any) => (
                            <TableRow key={index}>
                              <StyledTableCellBody
                                sx={{
                                  color: "#142C44",
                                  textTransform: "capitalize",
                                  fontSize: "14px",
                                }}
                              >
                                {index + 1}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  textTransform: "capitalize",
                                }}
                              >
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {`${report?.studentFirstName} ${report?.studentLastName}`}
                                  </div>
                                  <div
                                    style={{
                                      color: "#667085",
                                      fontSize: "13px",
                                      textTransform: "lowercase",
                                    }}
                                  >
                                    {report?.studentEmail}{" "}
                                    {report?.studentEmail &&
                                    report?.studentContact
                                      ? "|"
                                      : ""}{" "}
                                    {report?.studentContact
                                      ? `+${
                                          report?.contactCountryCode || "91"
                                        } ${
                                          report?.contactCountryCode
                                            ? report?.studentContact?.replace(
                                                report?.contactCountryCode,
                                                ""
                                              )
                                            : report?.studentContact?.startsWith(
                                                "91"
                                              )
                                            ? report?.studentContact?.replace(
                                                "91",
                                                ""
                                              )
                                            : report?.studentContact
                                        }`
                                      : "-"}
                                  </div>
                                </div>
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  textTransform: "capitalize",
                                }}
                              >
                                {report?.courseName}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  textTransform: "capitalize",
                                }}
                              >
                                {report?.batchName}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  textTransform: "capitalize",
                                  fontSize: "16px",
                                  color: "#1877F2",
                                  fontFamily: "Roboto",
                                }}
                              >
                                {report?.branchCurrency +
                                  "" +
                                  report?.amountReceived}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  textTransform: "capitalize",
                                  fontSize: "14px",
                                }}
                              >
                                {moment(report?.paymentDate).format(
                                  "DD/MM/YYYY,  hh:mm A"
                                )}
                              </StyledTableCellBody>

                              <StyledTableCellBody
                                sx={{
                                  textTransform: "capitalize",
                                  fontSize: "13px",
                                  color:
                                    report?.paymentStatus === "PAID"
                                      ? "#11C89B"
                                      : "#EC3939",
                                }}
                              >
                                {report?.paymentStatus === "PAID"
                                  ? "Successful"
                                  : "Failed"}
                              </StyledTableCellBody>
                              <StyledTableCellBody
                                sx={{
                                  textTransform: "capitalize",
                                  fontSize: "13px",
                                  color:
                                    report?.paymentMode === "ONLINE"
                                      ? "#11C89B"
                                      : "#EC3939",
                                  fontWeight: "600",
                                }}
                              >
                                {report?.paymentMode?.toLowerCase()}
                              </StyledTableCellBody>
                              <StyledTableCellBody>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  <Box
                                    ml={1}
                                    sx={{
                                      fontSize: "14px",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {report.paymentSource}
                                  </Box>
                                </Box>
                              </StyledTableCellBody>
                              <StyledTableCellBody>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  <Box
                                    ml={1}
                                    sx={{
                                      fontSize: "14px",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {report?.invoiceNumber
                                      ? report?.invoiceNumber
                                      : report?.receiptNumber}
                                  </Box>
                                </Box>
                              </StyledTableCellBody>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </div>
              </div>
            </Box>
          </Box>
        )}
        {openSaveReportPopup && (
          <SaveReportPopup
            openSaveReportPopup={openSaveReportPopup}
            setOpenSaveReportPopup={setOpenSaveReportPopup}
            handleSaveClick={handleSaveClick}
            saveReportLoading={saveReportLoading}
            description={description}
            setDescription={setDescription}
            reportName={reportName}
            setReportName={setReportName}
          />
        )}
        <CancelModal
          open={cancel}
          onClose={onCancel}
          noButtonClick={noCancelModal}
          yesButtonClick={yesCancelModal}
          subTitle={""}
          title={`Do you really want to close the report without saving it!!!`}
        />
      </Box>
    </>
  );
}

export default TransactionsReportCreation;
